import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Banner from '../Component/Banner';
import NavBar from '../Content/NavBar';
import Footer from '../Content/Footer';

function checkLightMode() {
    if (sessionStorage.getItem('lightMode') === 'true')  {
      return true
    }
  }

class ProjectsPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        // document.body.appendChild(script);
        window.addEventListener('resize',this.handleResize);
    }

    handleResize() {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight
            })
    }

    render () {
        return (
            <>
                <Container className="text-center">
                    <NavBar testProps= { checkLightMode() ? "light" : "dark" } className="navTest"/>
                        <Row className="justify-content-md-center">
                            <Banner caption="Chatbot AI"/>
                        </Row>
                        <Row className="divider">
                        <canvas id='javaCanvas' className={checkLightMode() ? "lightMode" : "darkMode"} width={this.state.width/2} height={this.state.height/2}/>
                        </Row>
                </Container>
                <Footer testProps= { checkLightMode() ? "lightMode" : "darkMode" }/>
            </>
        )
    }
}

export default ProjectsPage;